import React, { useState, useEffect } from 'react';
import { message, Modal, Upload } from 'components/shared/AntComponent';
import { Select } from 'components/shared/FormComponent';
import { useDispatch, useSelector } from 'react-redux';
import { submitCandidBulkUpload } from 'services/store/actions/candidateAction';
import { submitQuesBulkUpload } from 'services/store/actions/questionbankAction';
import { getCourse, getPublicCourse } from 'services/store/actions/masterDataAction';

const { Dragger } = Upload;

interface ChildProps {
    openModal: boolean;
    closeModal: () => void;
    callBackGrid: () => void;
    mid: number;
}

const ImportModal: React.FC<ChildProps> = ({ openModal, callBackGrid, closeModal, mid }) => {
    const dispatch = useDispatch();
    const { userProfileInfo } = useSelector((state: any) => state.auth);
    const { loading12, error12, success12 } = useSelector((state: any) => state.candidate);
    const { loading4, success4, error4 } = useSelector((state: any) => state.questionbank);
    const { courseInfo, loading21, pubCourseInfo,loading30 } = useSelector((state: any) => state.master);
    // const {loading}
    const [fileList, setFileList]: any = useState([]);
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success12 : false;
    const [showErrormsg, setShowErrormsg] = useState(false);
    const errormsg = showErrormsg ? error12 : false;
    //question paper indications
    const [showSuccessmsg1, setShowSuccessmsg1] = useState(false);
    const successmsg1 = showSuccessmsg1 ? success4 : false;
    const [showErrormsg1, setShowErrormsg1] = useState(false);
    const errormsg1 = showErrormsg1 ? error4 : false;
    const [inValidFile, setInValidFile] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState('');
    const apiUrl = process.env.REACT_APP_API_URL;
    const courseOptions = !loading30 && pubCourseInfo?.data?.map((item: any) => ({
        label: item?.courseName,
        value: item?.masCourseID,
        groupID: item?.groupID,
        groupName: item?.groupName
    }));

    const props1 = {
        onRemove: (file: any) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: () => {
            return false;
        },
        fileList,
    };

    const changeFile = (info: any) => {
        const filename = info?.fileList?.[0]?.name;
        const extension = filename?.split('.')?.pop();
        setFileList(info?.fileList);
        if (extension == 'xlsx' || extension == 'xls') {
            setFileList(info?.fileList);
            setInValidFile(false);
        } else {
            setInValidFile(true);
            setFileList([]);
        }
    };

    const handleSubmit = async () => {
        const formData = new FormData();
        try {
            let file = '';
            if (fileList) {
                file = fileList[0]?.originFileObj;
            } else {
                file = '';
            }
           
            if (mid == 1 || mid == 2 || mid == 3) {
                const inputJson = {
                    "candidate_type": mid
                }
                formData.append('file', file);
                formData.append('InputJson', JSON.stringify(inputJson));
                dispatch(submitCandidBulkUpload({ formData, apiUrl }) as any);
                setShowErrormsg(true);
                setShowSuccessmsg(true);
            } else {
                const inputJson = {
                    "course_name":selectedCourse?courseOptions?.find((item: any) => item.value === selectedCourse)?.label :"",
                    "courseid": selectedCourse || 0,
                    "group":selectedCourse?courseOptions?.find((item: any) => item.value === selectedCourse)?.groupName : "",
                    "tenantid": Number(localStorage.getItem('tenantID'))
                }
                formData.append('Docs', file);
                formData.append('InputJson', JSON.stringify(inputJson));
                dispatch(submitQuesBulkUpload(formData) as any);
                setShowErrormsg1(true);
                setShowSuccessmsg1(true);
            }


        } catch (error) {
            console.log("Failed", error);
        }

    }
    const handleClose = () => {
        closeModal();
        setInValidFile(false);
    };

    function getCourseList() {
        const id =  Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getPublicCourse(id) as any);
    }
    useEffect(() => {
        if (mid == 4 && userProfileInfo?.data && openModal) {
            getCourseList();
        }
    }, [mid, userProfileInfo, openModal]);

    useEffect(() => {
        if (successmsg) {
            if (success12?.data) {
                message.success(success12?.data);
            } else {
                message.success('Candidates imported successfully');
            }
            callBackGrid();
            setShowSuccessmsg(false);
            handleClose();
        }
        if (errormsg) {
            if (error12?.data) {
                message.error(error12?.data);
            } else {
                message.error("File couldn't be uploaded right now.")
            }
            setShowErrormsg(false);
        }
    }, [successmsg, errormsg]);

    useEffect(() => {
        if (successmsg1) {
            if (success4?.data) {
                message.success(success4?.data);
            } else {
                message.success('Candidates imported successfully');
            }
            callBackGrid();
            setShowSuccessmsg1(false);
            handleClose();
        }
        if (errormsg1) {
            if (error4?.message) {
                message.error(error4?.message);
            } else {
                message.error("File couldn't be uploaded right now.")
            }
            setShowErrormsg1(false);
        }
    }, [successmsg1, errormsg1]);

    useEffect(() => {
        if (openModal) {
            setInValidFile(false);
            setFileList([]);
        }

    }, [openModal]);

    const handleCourseChange = (e: any) => {
        setSelectedCourse(e);
    }

    return (
        <div>
            <Modal
                title={mid == 1 || mid == 2 || mid == 3 ? "Import Candidate" : "Import Questions"}
                confirmLoading={loading12 || loading4}
                open={openModal}
                width={800}
                onCancel={handleClose}
                onOk={handleSubmit}
                okText={'Upload'}
                cancelButtonProps={{
                    style: { backgroundColor: '#ff4242', color: 'white' }
                }}
            >
                {mid==4?
                <div className='mb-3'>
                    <label>Select Course</label>
                    <Select options={courseOptions}
                        onChange={handleCourseChange}
                        notFoundContent={
                            <div className="text-center p-4">
                                {loading21 ? (
                                    <span>
                                        {/* <LoadingOutlined /> */}
                                        Loading...
                                    </span>
                                ) : (
                                    <span>No course available</span>
                                )}
                            </div>
                        }
                        filterOption={(input: any, option: any) => (option?.label ?? '')?.toLowerCase().includes(input.toLowerCase())}
                    />
                </div>:""}

                <div className='cus-upload-btn'>
                    <Dragger
                        {...props1}
                        name="file"
                        className='w-100'
                        multiple={false}
                        maxCount={1}
                        beforeUpload={() => false}
                        fileList={fileList || []}
                        listType="picture-card"
                        onChange={changeFile}
                        accept={'.xlsx,.xls'}
                    >
                        <p className="ant-upload-drag-icon"></p>
                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                        <p className="ant-upload-hint">Upload file here</p>
                        <p className="ant-upload-hint text-danger">Supported file format: xlsx, xls</p>
                    </Dragger>
                    {inValidFile && (<div className='bg-danger text-white p-2'>Kindly upload only supported file format.</div>)}
                </div>
            </Modal>
        </div>
    )
}

export default ImportModal;